<!-- eslint-disable vue/no-v-html -->
<template>
  <span v-html="resultsCount" />
</template>

<script>
export default {
  name: 'SearchResultsCount',
  props: {
    isTeReo: {
      type: Boolean,
      required: true,
    },
    hits: {
      type: Number,
      required: true,
    },
  },
  computed: {
    resultsCount() {
      if (this.hits === 0)
        return this.isTeReo ? 'Kāore he hua i kitea' : 'Found <strong>0</strong> results';
      if (this.hits === 1)
        return this.isTeReo ? 'Kotahi te hua i kitea' : 'Found <strong>1</strong> result';
      return this.isTeReo
        ? `E <strong>${this.hits}</strong> ngā hua i kitea`
        : `Found <strong>${this.hits}</strong> results`;
    },
  },
};
</script>
